import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { HorizontalOperationsNav } from './ui/index.tsx';
import type { OverviewNav } from './ui/overview/index.tsx';

export const LazyHorizontalOperationsNav = lazyForPaint<typeof HorizontalOperationsNav>(() =>
	import(/* webpackChunkName: "jira-operations-horizontal-nav" */ './ui').then(
		({ HorizontalOperationsNav }) => HorizontalOperationsNav,
	),
);

export const LazyHorizontalOperationsOverviewNav = lazyForPaint<typeof OverviewNav>(() =>
	import(/* webpackChunkName: "jira-operations-horizontal-overview-nav" */ './ui').then(
		({ OverviewNav }) => OverviewNav,
	),
);

export const AsyncHorizontalOperationsNav = () => (
	<Placeholder name="horizontal-operations-nav" fallback={null}>
		<JSErrorBoundary
			id="asyncHorizontalOperationsNav"
			packageName="jiraOperationsHorizontalNav"
			fallback="flag"
			teamName="alexstrasza"
		>
			<LazyHorizontalOperationsNav />
		</JSErrorBoundary>
	</Placeholder>
);

export const AsyncHorizontalOperationsOverviewNav = () => (
	<Placeholder name="horizontal-operations-overview-nav" fallback={null}>
		<JSErrorBoundary
			id="asyncHorizontalOperationsOverviewNav"
			packageName="jiraOperationsHorizontalNav"
			fallback="flag"
			teamName="alexstrasza"
		>
			<LazyHorizontalOperationsOverviewNav />
		</JSErrorBoundary>
	</Placeholder>
);
